import { Component, Input } from '@angular/core';
import { alignOption, alignToolList } from '@models/editor';
import { CanvasService } from '@service/canvas/canvas.service';
import { SelectedElementsService } from '@service/canvas/selected-elements.service';

@Component({
    selector: 'app-alignment-options',
    templateUrl: './alignment-options.component.html',
    styleUrls: ['./../design-side-menu/design-side-menu.component.css', './alignment-options.component.css'],
    standalone: false,
})
export class AlignmentOptionsComponent {
    @Input() selectedElements;
    readonly ALIGN_TOOL_LIST = alignToolList;

    constructor(
        private canvasService: CanvasService,
        private selectionService: SelectedElementsService
    ) {}

    optionsAreDisabled() {
        if (this.selectedElements.length === 1 && this.selectedElements[0].tagName === 'g') {
            return false;
        }
        return this.selectedElements.length <= 1;
    }

    alignElements({ name, svgIcon }) {
        const canvas: any = this.canvasService.getCanvas();
        const previewSelectedElements = [...this.selectedElements];
        if (
            this.selectedElements.length === 1 &&
            this.selectedElements[0].tagName === 'g' &&
            this.selectedElements[0].childNodes
        ) {
            this.selectionService.setSelectedElements(this.selectedElements[0].childNodes);
        }
        switch (name) {
            case alignOption.left:
                canvas.alignSelectedElements('l', 'selected');
                break;
            case alignOption.centerHorizontal:
                canvas.alignSelectedElements('c', 'selected');
                break;
            case alignOption.right:
                canvas.alignSelectedElements('r', 'selected');
                break;
            case alignOption.top:
                canvas.alignSelectedElements('t', 'selected');
                break;
            case alignOption.centerVertical:
                canvas.alignSelectedElements('m', 'selected');
                break;
            case alignOption.bottom:
                canvas.alignSelectedElements('b', 'selected');
                break;
            default:
                console.error('alignemt not found');
        }
        this.selectionService.setSelectedElements(previewSelectedElements);
    }
}
